import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {landGreen} from '@modifi/colors'
import {InferPropTypes} from '@modifi/typescript-utils'
import {SkeletonLine} from '@modifi/ui'
import {
  ArrivalPort,
  DeparturePort,
  ShipIconWrapper,
  Path,
  ShipLineWrapper,
  ProgressIndicator,
} from './styles'
import {ShipIcon} from '../../../components'

const propTypes = {
  isLoading: PropTypes.bool.isRequired,
  progress: PropTypes.number.isRequired,
}

const defaultProps = {}

type ShipLineProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const ShipLine: React.FC<ShipLineProps> = ({isLoading, progress: progressProp}) => {
  const [progress, setProgress] = useState<number>(0)

  useEffect(() => {
    let frame: number
    const timeout = setTimeout(() => {
      frame = requestAnimationFrame(() => {
        setProgress(progressProp ?? 0)
      })
    }, 10)
    return () => {
      cancelAnimationFrame(frame)
      clearTimeout(timeout)
    }
  }, [progressProp])

  return (
    <ShipLineWrapper>
      {isLoading ? (
        <SkeletonLine width="100%" />
      ) : (
        <>
          <Path />
          <DeparturePort />
          <ProgressIndicator $progress={progress} />
          <ShipIconWrapper $progress={progress}>
            <ShipIcon color={landGreen} width={40} height={15} />
          </ShipIconWrapper>
          <ArrivalPort $completed={progress === 100} />
        </>
      )}
    </ShipLineWrapper>
  )
}

ShipLine.propTypes = propTypes
ShipLine.defaultProps = defaultProps

export default ShipLine
